// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.

import { useEffect } from 'react';

const APP_NAME = 'AesirX ComplianceOne';

/**
 * Sets document.title to "[pageTitle] | AesirX ComplianceOne".
 * Resets to previous title on unmount.
 */
export function usePageTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} | ${APP_NAME}` : APP_NAME;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
